
import { Mixins, Component } from "vue-property-decorator";
import SecuritySettingsMixin from "@/mixins/Security/SecuritySettingsMixin";

@Component
export default class NavigationDrawerListGroupAccount extends Mixins(
  SecuritySettingsMixin
) {}
